import { Segment, Label, Feed, Icon, Checkbox } from "semantic-ui-react";
import moment from "moment";

const ReminderRow = ({ reminder, days, saveReminder }) => (
	<div>
		{reminder && (
			<Feed>
				<Feed.Event>
					<Feed.Label icon="caret square right outline" />
					<Feed.Content>
						<Feed.Date>{moment(reminder.preregister.created_at).format("DD/MM/YYYY à HH:mm")}</Feed.Date>
						<Feed.Summary>
							<b>
								{reminder.preregister.first_name} {reminder.preregister.birth_name}
							</b>{" "}
						</Feed.Summary>
						<Feed.Extra text>
							<Icon name="at" /> {reminder.preregister.email}
							<br />
							<Icon name="calendar alternate outline" /> Validité de l'ordonnance : {moment(reminder.validity_date).format("DD/MM/YYYY")}
							<br />
						</Feed.Extra>
						{days === 2 && (
							<>
								<Feed.Meta>
									Rappel J-10 envoyé :{" "}
									{reminder.preregister.callBack10 && reminder.preregister.callBack10Date
										? `le ${moment(reminder.preregister.callBack10Date)}`
										: "non"}
								</Feed.Meta>
								<br />
							</>
						)}
						<Feed.Meta>
							Envoi du rappel J-{days}{" "}
							<Checkbox
								style={{ padding: "4px", marginRight: "10px" }}
								slider
								checked={days === 10 ? reminder.preregister.callBack10 : reminder.preregister.callBack2}
								onChange={(e) => {
									let callBack = !e.target.checked;
									let preregister = { ...reminder.preregister };
									if (days === 10) {
										preregister.callBack10 = callBack;
									} else {
										preregister.callBack2 = callBack;
									}
									saveReminder(preregister);
								}}
							/>
						</Feed.Meta>
					</Feed.Content>
				</Feed.Event>
			</Feed>
		)}
	</div>
);

export default ReminderRow;
